import {useEffect, memo} from 'react';
import {machine as m} from "../../../constants/machine.constants";
import {useMainStateMachine} from "../../MainStateMachineProvider";
import {useSelector} from "@xstate/react";

const PauseText = memo(({cardIndex, scenarioIndex}) => {
    const {actor, send} = useMainStateMachine()
    
    const isActive = useSelector(actor, (s) => 
        cardIndex === s.context.currentCardIndex && scenarioIndex === s.context.currentScenarioIndex
    );
    const isPlayingScenario = useSelector(actor, (s) => 
        isActive && s.matches(m.state.playingScenario)
    );

    useEffect(() => {
        if (isActive && isPlayingScenario) {
            send({type: m.events.PAUSE_TEXT})
        }
    }, [isActive, isPlayingScenario, send]);

    return null;
});

const pauseTextProps = ["cardIndex", "scenarioIndex"]

export {PauseText, pauseTextProps};